import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
export const StyledTypographhheroheanding = styled(Typography)({
	fontSize: '40px',
	fontWeight: '700',
	variant: 'h2',
	textAlign: 'start',
	color: 'black',
});
export const StyledTypographList = styled('li')({
	fontSize: '14px',
	// fontWeight: '700',
	listStyle: 'none',
	textAlign: 'start',
	variant: 'h6',
	lineHeight: '30px',
});
export const StyledTypographDiv = styled(Typography)({
	fontSize: '14px',
	listStyle: 'none',
	textAlign: 'start',
	variant: 'h6',
	marginTop: '12px', // lineHeight: '40px',
	display: 'flex',
});
export const Root = styled('div')({
	backgroundImage: 'url("/assets/hero-banner.png")',
	backgroundSize: 'cover',
	backgroundRepeat: 'no-repeat',
	width: '100%',
	// Remove duplicate height
	// height: '876px',
	minHeight: 'auto',
	height: 'calc(100vh - 60px)', // this is now correct
	maxHeight: '655px',
	position: 'relative',
	// display: 'flex',
	// alignItems: 'center',
	// justifyContent: 'center',
	zIndex: '0',
});

// export const Container = styled('div')(({ theme }) => ({
export const Container = styled(Typography)(() => ({
	// padding: {{ xs: theme.spacing(2), md: theme.spacing(4) }},
	maxWidth: '1200px',
	width: '100%',
}));

export const TextContainer = styled(Typography)(({ theme }) => ({
	maxWidth: '700px',
	marginBottom: theme.spacing(6),
	fontFamily: 'Poppins',
}));

const slideUpAnimation = `
  @keyframes slideUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
    from {
      opacity: 0;
      transform: translateY(20px);
    }
  }
`;

export const SlideUp = styled('div')({
	animation: `${slideUpAnimation} 0.5s forwards`,
	// opacity: 0,
});
export const StyledIconButton = styled(IconButton)({
	backgroundColor: '#CD3131',
	color: '#fff',
	transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out',
	'&:hover': { backgroundColor: '#fff', color: '#CD3131' },
});
